module.exports = __webpack_public_path__ + "static/img/cocinas1.4ca68603.jpg";